import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PATIENT_LIMITS } from 'src/app/shared/app.constants';
import { ConversionWeightService } from '../../services/conversion/conversion-weight.service';
import { WeightUnit } from '../header/components/interface/interface';

@Component({
  selector: 'app-weight-input',
  standalone: true,
  templateUrl: './weight-input.component.html',
  styleUrls: ['./weight-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppWeightInputComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, MatInputModule, FormsModule, MatFormFieldModule],
})
export class AppWeightInputComponent
  implements ControlValueAccessor, OnChanges
{
  WeightUnit = WeightUnit;
  limits = PATIENT_LIMITS.weight;
  isFocused = false;
    isHovered = false;
  public ngControl: NgControl | null = null;

  @Input() weightInKg: any = 0;
  @Output() weightChange = new EventEmitter<number>();

  kg: number | null = null;
  lb: number | null = null;

  private _onChange: (value: number) => void = () => {};
  private _onTouched: () => void = () => {};

  constructor(
    public conversionWeightService: ConversionWeightService,
    private cdr: ChangeDetectorRef,
    private injector: Injector
  ) {}

  ngOnInit(): void {
    try {
      this.ngControl = this.injector.get(NgControl, null);
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
        this.ngControl.statusChanges?.subscribe(() => {
          this.cdr.markForCheck();
        });
      }
    } catch (e) {
      console.warn('NgControl not found for weight input:', e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['weightInKg']) {
      this.updateWeightValues();
    }
  }

  writeValue(value: number): void {
    if (value !== undefined && value !== null) {
      this.weightInKg = value;
      this.updateWeightValues();
    }
  }

  registerOnChange(fn: (value: number) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  updateWeightValues(): void {
    const weight = this.weightInKg;

    if (this.conversionWeightService.preferredWeightUnit === WeightUnit.LB) {
      this.lb = parseFloat((weight * 2.20462).toFixed(2)); // kg → lb
      this.kg = null;
    } else {
      this.kg = weight;
      this.lb = null;
    }
  }

  onInputChange(): void {
    let normalizedKg: number | null = null;

    if (this.conversionWeightService.preferredWeightUnit === WeightUnit.LB) {
      const parsed = parseFloat(this.lb as any);
      normalizedKg = isNaN(parsed) ? null : parsed / 2.20462;
    } else {
      const parsed = parseFloat(this.kg as any);
      normalizedKg = isNaN(parsed) ? null : parsed;
    }

    this.weightInKg = normalizedKg;

    // Update ControlValueAccessor and parent
    this._onChange(normalizedKg);
    this.weightChange.emit(normalizedKg);
  }

  onBlur(): void {
    this._onTouched();
    this.isFocused = false;
  }

  onFocus() {
    this.isFocused = true;
  }



onMouseEnter(): void {
  this.isHovered = true;
}

onMouseLeave(): void {
  this.isHovered = false;
}
}
